import { apiRequest } from "@/api/client";
import type { User } from "./AuthContext";

export function exchangeCode(code: string, redirectPath = "/login") {
  return apiRequest<User>("/api/auth/exchange-code", {
    method: "POST",
    body: JSON.stringify({ code, redirect_path: redirectPath }),
  });
}

export function fetchCurrentUser() {
  return apiRequest<User>("/api/user/info");
}

export function logout() {
  return apiRequest<{ logout_url: string }>("/api/auth/logout", {
    method: "POST",
  });
}
